import React, { useEffect, useRef } from 'react';
import foto from '../../../media/img/home/home_iddi_innovation.jpg';
import './innovationDevelopment.scss';

const InnovationDevelopment = () => {
  const lineRefs = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px 0px 0px',
    };

    const lineObservers = lineRefs.current.map((lineRef) => {
      if (!lineRef) return null;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('content__title-line--visible');
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);

      observer.observe(lineRef);
      return observer;
    });

    return () => {
      lineObservers.forEach((obs) => obs?.disconnect());
    };
  }, []);

  return (
    <div>
      <section className="innovation-section">
        <div className="innovation-section__header">
          <h1 className="innovation-section__title">I+D+i</h1>
          <div
            ref={(el) => (lineRefs.current[0] = el)}
            className="content__title-line"
          />
          <p className="innovation-section__description content__text-title-backgroundWhite">
            Impulsamos la investigación, el desarrollo y la innovación
            integrando neuropsicología y tecnología avanzada en la industria
            audiovisual, desde la concepción del proyecto hasta su
            implementación.
          </p>
        </div>

        <div className="innovation-section__grid">
          <div className="innovation-section__image-container">
            <img
              className="innovation-section__image"
              alt="I+D+i Wonderaly Innovations"
              src={foto}
            />
          </div>

          <div className="innovation-section__content">
            <h2 className="innovation-section__content-title">
              NUESTROS PILARES
            </h2>
            <p className="innovation-section__content-subtitle">
              Ciencia aplicada al arte para resultados extraordinarios
            </p>
            <p className="innovation-section__content-text">
              A través de nuestros pilares, desarrollamos metodologías precisas
              alineadas con los objetivos creativos y estratégicos de cada
              producción.
            </p>
            <ul className="innovation-section__features">
              <li className="innovation-section__feature-item">
                <span className="innovation-section__feature-icon">✓</span>
                Neuropsicología aplicada a la producción audiovisual
              </li>
              <li className="innovation-section__feature-item">
                <span className="innovation-section__feature-icon">✓</span>
                Inteligencia Artificial y análisis predictivo del público
              </li>
              <li className="innovation-section__feature-item">
                <span className="innovation-section__feature-icon">✓</span>
                Business Intelligence para decisiones creativas
              </li>
              <li className="innovation-section__feature-item">
                <span className="innovation-section__feature-icon">✓</span>
                Innovación basada en neurociencia y datos
              </li>
            </ul>

            <div className="innovation-section__link-conteiner">
              <a href="/I+D+i" className="innovation-section__link">
                Explora nuestros proyectos I+D+i &#8594;
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default InnovationDevelopment;
